export default {"src":"/_next/static/media/dhl_logo.fc44cfc0.svg","height":24,"width":49,"blurWidth":0,"blurHeight":0};